import BreadCrumb from "../../../components/BreadCrumb";
import Layout from "../../../components/Layout";
import useStyles from "../styles";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { httprequest } from "../../../data/api";
import { useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Button from "../../../components/Button";
import useValidator from "../../../hooks/useValidator";
import Modal from "../../../components/Modal";
import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { MessageList } from "react-chat-elements";
import "react-chat-elements/dist/main.css";
import { useUserState } from "../../../context/UserContext";
import { ChatRole } from "../../../utils/DropDown";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Select from "react-select";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import useWindowSize from "../../../hooks/useWindow";

const HOSTEL_EDIT_ENDPOINT = "/api/v1/hostel-management/hostel/";
const HOSTEL_GROUP_CHAT = "/api/v1/hostel-management/hostel-group-chats";
const HOSTEL_GROUP = "/api/v1/hostel-management/hostel-group-chat/";
const UPLOAD_ENDPOINT = "/api/v1/upload";
const HOSTEL_CHAT = "/api/v1/hostel-management/hostel-group/";
const STUDENT_ENDPOINT = "/api/v1/students";

const HostelMessage = () => {
  const { id } = useParams();
  const { userRole, profile } = useUserState();
  const emojiRef = useRef();
  const chatContainerRef = useRef(null);
  const classes = useStyles();
  const { width } = useWindowSize();
  const mobile = width < 744;
  const [hostels, setHostels] = useState([]);
  const [hostelRooms, setHostelRooms] = useState([]);
  const [hostelGroupChats, setHostelGroupChats] = useState([]);
  const [groupChatModal, setGroupChatModal] = useState(false);
  const [editgroupChatModal, setEditGroupChatModal] = useState(false);
  const [deleteGropModal, setDeleteGroupModal] = useState(false);
  const [isGroupChat, setIsGroupChat] = useState(false);
  const [inputMessage, setInputMessage] = useState("");
  const [groupchatValidator, showGroupChatValidator] = useValidator();
  const [editgroupchatValidator, showEDitGroupChatValidator] = useValidator();
  const [participantValidator, showParticipantValidator] = useValidator();
  const [selectedChatId, setSelectedChatId] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isGroupDeleting, setIsGroupDeleting] = useState(false);
  const [participant, setParticipant] = useState(false);
  const [isparticipating, setIsParticipating] = useState(false);
  // const [uploadedAttachments, setUploadedAttachments] = useState([]);
  const [pendingAttachments, setPendingAttachments] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [messages, setMessages] = useState([]);
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [memberModal, setMemberModal] = useState(false);
  const [editChatItem, setEditChatItem] = useState({});
  const [studentData, setStudentsData] = useState([]);
  const [groupMembers, setGroupMembers] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };
  const [participants, setParticipants] = useState({
    role: "",
    user_ids: []
  });
  const [groupChatForm, setGroupChatForm] = useState({
    title: ""
  });
  const [editgroupChatForm, setEditGroupChatForm] = useState({
    title: ""
  });

  const handleMembersModal = () => {
    setMemberModal(!memberModal);
  };

  const handleOpenParticipantModal = () => {
    setParticipant(true);
  };

  const handleCloseParticipantModal = () => {
    setParticipant(false);
    setParticipants({
      role: "",
      user_ids: []
    });
  };

  const handleParticipateChange = (e) => {
    const { name, value } = e.target;

    // If hostel_id changes, fetch hostel rooms
    // if (name === "hostel_id" && value) {
    //   getAllHostelRoom(value);
    // }
    // Update the allocations state
    setParticipants((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleGetHostelMembers = (chat_id) => {
    httprequest.get(`${HOSTEL_EDIT_ENDPOINT}${chat_id}/members`).then((res) => {
      setGroupMembers(res?.data?.members);
      // toast.success(res?.data?.message);
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  const getMessagesByGroupId = async (chatId) => {
    try {
      const res = await httprequest.get(`${HOSTEL_CHAT}${chatId}/all-messages`);

      const msgs = res?.data?.messages?.flatMap((msg) => {
        const baseProps = {
          position: msg?.ref_id === userRole?.id ? "right" : "left",
          date: new Date(msg?.created_at),
          title: `${msg?.sender?.first_name} ${msg?.sender?.last_name}`
        };

        const result = [];

        // If message text exists, add it as a text message
        if (msg?.message) {
          result.push({
            ...baseProps,
            type: "text",
            text: msg.message
          });
        }

        // If there are attachments, add each one as a separate photo message
        if (msg?.attachments?.length) {
          msg?.attachments?.forEach((att) => {
            result.push({
              ...baseProps,
              type: "photo",
              text: "",
              data: {
                uri: att.url
              }
            });
          });
        }

        return result;
      }) || [];

      setMessages(msgs);
      setTimeout(() => {
        if (chatContainerRef?.current) {
          chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
      }, 100);
    } catch (err) {
      toast.error("Failed to load messages");
    }
  };

  const sendMessage = async () => {
    if (!inputMessage.trim() && pendingAttachments.length === 0) return;
    if (!selectedChatId) return toast.error("Select a chat group");

    const messagePayload = {
      ref_id: profile?.user_id,
      // ref_type: userRole?.role_type,
      message: inputMessage.trim(),
      attachments: pendingAttachments
    };

    try {
      const res = await httprequest.post(
        `${HOSTEL_CHAT}${selectedChatId}/message`,
        messagePayload
      );

      if (res?.status === 200) {
        setInputMessage("");
        setPendingAttachments([]);
        getMessagesByGroupId(selectedChatId);
        handleGetHostelMembers(selectedChatId);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Message failed");
    }
  };

  const handleImageAttach = async (e) => {
    const files = Array.from(e.target.files);
    const formData = new FormData();
    files.forEach((file) => formData.append("file", file));

    setIsUploading(true);
    setUploadProgress(0);

    try {
      const response = await httprequest.post(`${UPLOAD_ENDPOINT}`, formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        }
      });

      if (response?.status === 200 && response?.data?.data) {
        const uploadedImages = response.data.data.map((file) => ({
          upload_id: file?.upload_id,
          url: file.file_url
        }));

        setPendingAttachments((prev) => [...prev, ...uploadedImages]);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Upload failed");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const handleGroupChatChange = (e) => {
    const { name, value } = e.target;
    setGroupChatForm({ ...groupChatForm, [name]: value });
  };
  const handleEDitGroupChatChange = (e) => {
    const { name, value } = e.target;
    setEditGroupChatForm({ ...editgroupChatForm, [name]: value });
  };

  /**
     * Fetches all students and separates them into active/inactive categories.
     * Also handles loading state and error toasts.
     */
  const getAllStudents = () => {
    httprequest.get(STUDENT_ENDPOINT).then((res) => {
      setStudentsData(res?.data?.data?.filter((active_stn) => active_stn?.is_active === true)?.map((stdn) => {
        return {
          label: `${stdn?.student?.last_name} ${stdn?.student?.first_name}`,
          value: stdn?.user_id
        };
      }));
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  const handleAddParticipants = () => {
    if (participantValidator.allValid()) {
      setIsParticipating(true);
      httprequest.post(`${HOSTEL_EDIT_ENDPOINT}${selectedChatId}/add-participant`, participants).then((res) => {
        setIsParticipating(false);
        handleGetHostelMembers(selectedChatId);
        toast.success(res?.data?.message);
      }).catch((err) => {
        setIsParticipating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showParticipantValidator(true);
    }
  };

  const handleGroupChatModal = () => {
    setGroupChatModal(!groupChatModal);
  };

  const handleCloseGroupChat = () => {
    setGroupChatModal(false);
    setGroupChatForm({ ...groupChatForm, title: "" });
  };

  const handleDeleteGroup = (row) => {
    setEditChatItem(row);
    setDeleteGroupModal(true);
  };

  const handleCloseDeleteGroup = () => {
    setEditChatItem({});
    setDeleteGroupModal(false);
  };

  const handleEDitGroupChatModal = (row) => {
    setEditChatItem(row);
    setEditGroupChatModal(true);
    setEditGroupChatForm({ ...editgroupChatForm, title: row?.title });
  };

  const handleCloseEditGroupChat = () => {
    setEditGroupChatModal(false);
    setEditChatItem({});
    setEditGroupChatForm({ ...editgroupChatForm, title: "" });
  };

  /**
       * Fetches Hostel by ID
       */
  const getAllHostelbyID = () => {
    httprequest.get(`${HOSTEL_EDIT_ENDPOINT}${id}`).then((res) => {
      setHostels(res?.data?.data);
      setHostelRooms(res?.data?.rooms);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };
  /**
       * Fetches All Group Chats
       */
  const getAllGroupChats = () => {
    setLoadingGroups(true);
    httprequest.get(`${HOSTEL_GROUP_CHAT}`).then((res) => {
      setHostelGroupChats(res?.data?.data);
      const chat_id = res?.data?.data?.[0]?.chat_id;
      if (chat_id) {
        setSelectedChatId(chat_id);
        getMessagesByGroupId(chat_id);
        handleGetHostelMembers(chat_id);
      }
      setLoadingGroups(false);
      handleCloseParticipantModal();
    }).catch((err) => {
      setLoadingGroups(false);
      toast.error(err?.response?.data);
    });
  };

  const handleCreateGroupChat = () => {
    if (groupchatValidator.allValid()) {
      setIsGroupChat(true);
      httprequest.post(`${HOSTEL_EDIT_ENDPOINT}${id}/create`, groupChatForm).then((res) => {
        setIsGroupChat(false);
        toast.success(res?.data?.message);
        handleCloseGroupChat();
        getAllGroupChats();
      }).catch((err) => {
        setIsGroupChat(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showGroupChatValidator(true);
    }
  };
  const handleEDitGroupChat = () => {
    if (editgroupchatValidator.allValid()) {
      setIsGroupChat(true);
      httprequest.patch(`${HOSTEL_GROUP}${editChatItem?.chat_id}`, editgroupChatForm).then((res) => {
        toast.success(res?.data?.message);
        handleCloseEditGroupChat();
        getAllGroupChats();
      }).catch((err) => {
        setIsGroupChat(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showEDitGroupChatValidator(true);
    }
  };
  const handleDeleteGroupChat = () => {
    setIsGroupDeleting(true);
    httprequest.delete(`${HOSTEL_GROUP}${editChatItem?.chat_id}`).then((res) => {
      toast.success(res?.data?.message);
      handleCloseEditGroupChat();
      getAllGroupChats();
    }).catch((err) => {
      setIsGroupDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const handleStudentChange = (selectedOptions) => {
    const studentIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
    setParticipants((prev) => ({
      ...prev,
      user_ids: studentIds
    }));
  };

  useEffect(() => {
    getAllHostelbyID();
    getAllGroupChats();
    getAllStudents();
  }, []);

  // Effect to handle automatic sidebar state on resize
  useEffect(() => {
    // On mobile, force close the sidebar
    if (mobile) {
      setSidebarOpen(false);
    } else {
      // On desktop, force open the sidebar
      setSidebarOpen(true);
    }
  }, [mobile, width]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (emojiRef.current && !emojiRef.current.contains(event.target)) {
        setShowEmojiPicker(false);
      }
    };

    if (showEmojiPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showEmojiPicker]);

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one={`/hostel/${id}`}
              link_one_name="Hostel Management"
              active={hostels?.hostel?.name || "Hostel Information"}
              description="See details of messages in a hostel"
            />
          </div>
          <div className="flex gap-10">
            <Button
              onClick={handleGroupChatModal}
              variant="primary"
              buttonSize="medium"
              color="btndefault"
              buttonName="Create Group Chat"
            />
          </div>
        </div>
        <div className="page-content margin-top-16">
          <div className="flex_space gap-10">
            <div className={classes.hosteldetail}>
              <h2>{hostels?.hostel?.name || "Hostel Information"}</h2>
              <p>{hostels?.hostel?.gender} Hostel | {hostels?.hostel?.number_of_rooms}-Man Room</p>
            </div>
          </div>

          <div className={classes.wrapper}>
            {/* Sidebar */}
            <div
              className={`${classes.sidebar} ${
                sidebarOpen ? classes.sidebarOpen : classes.sidebarCollapsed
              }`}
            >
              <div className={classes.navTop}>
                <Icon
                  icon={sidebarOpen ? "mdi:chevron-left" : "mdi:chevron-right"}
                  onClick={toggleSidebar}
                  className={classes.backIcon}
                />
                {sidebarOpen && <span>Hide</span>}
              </div>

              {sidebarOpen && (
                <>
                  <div className={classes.tabNav}>
                    <p>Group(s)</p>
                    <p>{hostelGroupChats?.length || 0}</p>
                  </div>
                  <div className={classes.chatList}>
                    {loadingGroups ? (
                      <div className={classes.chatTileActive}>
                        <p className={classes.chatSub}>Getting Groups ...</p>
                      </div>
                    ) : hostelGroupChats?.length > 0 ? (
                      hostelGroupChats.map((group, index) => (
                        <div
                          key={index}
                          onClick={() => {
                            setSelectedChatId(group?.chat_id);
                            getMessagesByGroupId(group?.chat_id);
                          }}
                          className={
                            selectedChatId === group?.chat_id
                              ? classes.chatTiles
                              : classes.chatTileActive
                          }
                        >
                          <div className={classes.chatTileText}>
                            <p className={classes.chatTitle}>{group?.title}</p>
                            <p className={classes.chatSub}>{group?.sub}</p>
                          </div>
                          <div>
                            <div className="table-action-container">
                              <button
                                className="table-action-icon"
                                onClick={() => handleEDitGroupChatModal(group)}
                              >
                                <Icon icon="heroicons:pencil-square-solid" />
                              </button>
                              <button
                                className="table-action-icon"
                                onClick={() => handleDeleteGroup(group)}
                              >
                                <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
                              </button>
                            </div>
                            <span className={classes.chatTime}>{group?.created_at?.substring(0, 10)}</span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className={classes.chatTileActive}>
                        <p className={classes.chatSub}>No Group Has been Created</p>
                      </div>
                    )}

                    {/* <p className={classes.sectionLabel}>
                  <Icon icon="uim:comment-message" />
            ROOMS
                </p> */}

                    {hostelRooms?.map((room, index) => (
                      <div key={index} className={classes.chatTile}>
                        <div className={classes.chatTileText}>
                          <p className={classes.chatTitle}>{room?.room_number}</p>
                          <p className={classes.chatSub}>Capacity: {room?.capacity}</p>
                        </div>
                        <span className={classes.chatTime}>10:25 AM</span>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>

            {/* Chat Panel */}
            <div className={classes.chatPanel}>
              <div className={classes.chatHeader}>
                <p className={classes.chatHeading}>Hostel Group Chat</p>
                <div className="flex gap-10">
                  <a onClick={handleMembersModal} href="#" className={classes.memberLink}>
                    view members
                  </a>
                  <Icon onClick={handleOpenParticipantModal} className={classes.addnew} icon="basil:add-outline" width="20" height="20" />
                </div>
              </div>
              <div className={classes.chatBody}>
                <div className={classes.chatHeight} ref={chatContainerRef}>
                  <MessageList
                    // className="message-list"
                    lockable={true}
                    toBottomHeight="100%"
                    dataSource={messages}
                  />
                </div>
              </div>

              {pendingAttachments.length > 0 && (
                <div className={classes.imageFlexing}>
                  {pendingAttachments.map((img, idx) => (
                    <div key={idx} style={{ position: "relative" }}>
                      <img
                        src={img.url}
                        alt={`attachment-${idx}`}
                        className={classes.pendingImage}
                      />
                      <span
                        onClick={() => setPendingAttachments((prev) => prev.filter((_, i) => i !== idx))
                        }
                        className={classes.pendingAttachments}
                      >
          ×
                      </span>
                    </div>
                  ))}
                </div>
              )}

              {/* Chat Input */}
              {isUploading && (
                <div
                  style={{
                    height: "4px",
                    background: "#00AB55",
                    width: `${uploadProgress}%`,
                    transition: "width 0.3s ease-in-out",
                    marginBottom: "2px"
                  }}
                />
              )}
              {hostelGroupChats?.length > 0 ? (
                <div className={classes.chatInputArea}>
                  <Icon onClick={() => setShowEmojiPicker((prev) => !prev)} icon="mdi:emoticon-outline" className={classes.icon} />
                  {showEmojiPicker && (
                    <div ref={emojiRef} className={classes.emojiPicker}>
                      <Picker data={data} onEmojiSelect={(emoji) => setInputMessage(prev => prev + emoji.native)} />
                    </div>
                  )}
                  <label htmlFor="image-upload">
                    <Icon icon="mdi:attachment" className={classes.icon} style={{ cursor: "pointer", marginTop: "5px" }} />
                  </label>
                  {/* Hidden file input */}
                  <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    multiple
                    style={{ display: "none" }}
                    onChange={handleImageAttach}
                  />

                  <textarea
                    className={classes.chatInput}
                    placeholder="Message.."
                    value={inputMessage}
                    onChange={(e) => setInputMessage(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        sendMessage();
                      }
                    }}
                    rows={1}
                  />

                  <button onClick={sendMessage} className={classes.sendButton}>
                    <Icon icon="mdi:send" />
                  </button>
                </div>
              ) : null}

            </div>
          </div>
        </div>
        {/* Create Hostel Group Chat */}
        <Modal
          title="Create Hostel Group Chat"
          subtitle={
            <div>
              Create hostel group chat by filling in the details below.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Chat Title"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="title"
                    onChange={handleGroupChatChange}
                  />
                  {groupchatValidator.message("Chat Title", groupChatForm?.title, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Create Group Chat"
                  onClick={handleCreateGroupChat}
                  isLoading={isGroupChat}
                />
              </div>
            </>
          }
          isopen={groupChatModal}
          closeModal={handleCloseGroupChat}
        />
        {/* Edit Hostel Group Chat */}
        <Modal
          title="Edit Hostel Group Chat"
          subtitle={
            <div>
              Create hostel group chat by filling in the details below.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Chat Title"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="title"
                    defaultValue={editChatItem?.title}
                    onChange={handleEDitGroupChatChange}
                  />
                  {editgroupchatValidator.message("Chat Title", editgroupChatForm?.title, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Edit Group Chat"
                  onClick={handleEDitGroupChat}
                  isLoading={isGroupChat}
                />
              </div>
            </>
          }
          isopen={editgroupChatModal}
          closeModal={handleCloseEditGroupChat}
        />
        {/* Delete Modal */}
        <Modal
          title="Delete Group"
          subtitle={`Are you sure you want to delete ${editChatItem?.title}`}
          modalContent={
            <>
              <div>
              </div>
            </>
          }
          modalFooter={
            <>
              <Button
                variant="danger"
                buttonName="Delete Group Chat"
                buttonSize="full"
                color="btndefault"
                onClick={handleDeleteGroupChat}
                isLoading={isGroupDeleting}
              />
            </>
          }
          isopen={deleteGropModal}
          closeModal={handleCloseDeleteGroup}
        />
        {/* Allocate Hostels */}
        <Modal
          title="Add Pariticipants"
          subtitle={
            <div>
                Add Participants to your hostel group chat
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div className="multiple-select">
                    <p>Students</p>
                    <Select
                      name="students"
                      options={studentData}
                      placeholder="Select a student"
                      isMulti
                      isClearable
                      onChange={handleStudentChange}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </div>
                  {participantValidator.message("Students", participants?.user_ids, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup required label="Role" children={
                    <select name="role" onChange={handleParticipateChange}>
                      <option value="">--- Select ---</option>
                      {ChatRole?.map((conditions) => {
                        return (
                          <option key={conditions?.key} value={conditions?.key}>{conditions?.text}</option>
                        );
                      })}
                    </select>
                  }
                  />
                  {participantValidator.message("Role", participants?.role, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Add Participant"
                  onClick={handleAddParticipants}
                  isLoading={isparticipating}
                />
              </div>
            </>
          }
          isopen={participant}
          closeModal={handleCloseParticipantModal}
        />
        <Modal
          title="Group Members"
          subtitle={
            <div>
                See all Hostel Members
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2}>
                {groupMembers && groupMembers.length > 0 ? (
                  groupMembers.map((member, index) => (
                    <Grid item xs={12} sm={12} md={12} key={index}>
                      <div
                        className={classes.memberBox}
                        style={{ marginTop: index === 0 ? 32 : 0 }}
                      >
                        <div className={classes.name}>{member?.full_name}</div>
                        <div className={classes.role}>
                          {member?.role?.replace("_", " ")}
                        </div>
                      </div>
                    </Grid>
                  ))
                ) : (
                  <Grid item xs={12}>
                    <div className={classes.noMember}>
      No member has been added
                    </div>
                  </Grid>
                )}

              </Grid>
            </>
          }
          modalFooter={
            <>
            </>
          }
          isopen={memberModal}
          closeModal={handleMembersModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default HostelMessage;
